import React from "react";
import "./AboutSlider.scss";
import { sliderImages } from "../../data/data";

const AboutSlider = () => {
  return (
    <section className="aboutSlider">
      <article className="aboutSlider__container container">
        <div className="aboutSlider__container--contents">
          {sliderImages.map((image, index) => (
            <figure
              key={index}
              className="aboutSlider__container--contents-items"
            >
              <img
                src={image.src}
                width={image.width}
                height={image.height}
                alt={image.alt}
                title="About Slider Image"
              />
            </figure>
          ))}
        </div>
      </article>
    </section>
  );
};

export default AboutSlider;
